import { environment } from 'environments/environment';

function organizations(): any[] {
    return Array.isArray(environment.user?.organizations) ? environment.user!.organizations! : [];
}

export function resolveWorkspaceOrganizationCode(): string | null {
    const selected =
        environment.selection?.organization?.code ??
        environment.selection?.organization?.slug ??
        null;
    if (selected) {
        return `${selected}`.trim() || null;
    }

    const orgs = organizations();
    if (orgs.length === 1) {
        const only = orgs[0];
        return `${only?.code || only?.slug || ''}`.trim() || null;
    }

    if (orgs.length > 1) {
        const first = orgs[0];
        return `${first?.code || first?.slug || ''}`.trim() || null;
    }

    return null;
}

export function resolveWorkspaceOrganizationName(): string {
    return (
        environment.selection?.organization?.name ||
        environment.selection?.organization?.code ||
        organizations()[0]?.name ||
        organizations()[0]?.code ||
        'Organization'
    );
}

export function resolveWorkspaceBranchCode(): string {
    return (
        environment.selection?.branch?.code ||
        environment.selection?.branch?.slug ||
        organizations()[0]?.branches?.[0]?.code ||
        'main'
    );
}

export function resolveWorkspaceBranchName(): string {
    return (
        environment.selection?.branch?.name ||
        environment.selection?.branch?.code ||
        organizations()[0]?.branches?.[0]?.name ||
        resolveWorkspaceBranchCode()
    );
}

export function hasResolvableWorkspaceOrganization(): boolean {
    return !!resolveWorkspaceOrganizationCode();
}
